import styled from "styled-components";

export const CartContainer = styled.main`
  display: flex;
  flex-direction: column;
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  max-width: 100%;

  .textTitle {
    font-weight: 700;
    font-size: 1.25rem;
    line-height: 1.5rem;
    color: #460259;
  }
`;

export const CartContent = styled.section`
  display: flex;
  margin-bottom: 2rem;
  width: 100%;
  gap: 1rem;

  .contentItems {
    display: flex;
    flex-direction: column;
    border: 1px solid #dedede;
    width: max-content;
    border-radius: 5px;
    padding: 1.5rem;
    height: ${process.env.REACT_APP_ZKP === "true" ? null : "max-content"};
    width: 100%;
  }

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const TransactionComplete = styled.section`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.tertiary};
  width: 20rem;
  gap: 1rem;

  .btnDeepLink {
    align-items: center;
    flex-direction: column;
    padding: 0.75rem 0.625rem;
    border: 1px solid #dedede;
    width: 100%;
    border-radius: 5px;

    a {
      display: flex;
      align-items: center;
      justify-content: space-around;
      padding: 0.75rem 0.625rem;
      background: ${({ theme }) => theme.backgrounds.defaultGradient};
      color: ${({ theme }) => theme.colors.primary};
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
      text-decoration: none;
      border-radius: 5px;
      border: none;
      width: 100%;
    }

    h3 {
      font-weight: 700;
      line-height: 1.5rem;
      font-size: 1rem;
    }

    p {
      padding: 0.75rem 0.625rem;
      color: ${({ theme }) => theme.black[900]};
      font-weight: 400;
      font-size: 0.875rem;
      line-height: 128%;
      text-align: center;

      span {
        font-weight: 700;
      }
    }
  }

  .btnDeepLinkClearsale {
    background: ${({ theme }) => theme.backgrounds.defaultGradient};
    display: flex;
    padding: 1rem;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.75rem;
    align-self: stretch;
    color: #fff;
    border-radius: 5px;

    h3 {
      font-size: 0.9375rem;
      font-weight: 600;

      span {
        font-weight: 700;
      }
    }

    a {
      display: flex;
      width: 17.5rem;
      height: 3.75rem;
      padding: 0.75rem 0rem;
      justify-content: center;
      align-items: center;
      background: ${({ theme }) => theme.backgrounds.defaultPrimaryClearsale};
      border-radius: 5px;
      color: #fff;
      text-decoration: none;
      width: 100%;
    }

    p {
      padding: 0.75rem 0.625rem;
      color: #fff;
      font-weight: 400;
      font-size: 0.875rem;
      line-height: 128%;
      text-align: center;
      border: 2px solid
        ${({ theme }) => theme.backgrounds.defaultPrimaryClearsale};
      border-radius: 5px;

      span {
        font-weight: 700;
      }
    }
  }

  .infoComplete {
    display: flex;
    align-items: ${process.env.REACT_APP_CLEARSALE === "false"
      ? "center"
      : "flex-start"};
    flex-direction: column;
    background: ${({ theme }) => theme.backgrounds.defaultGradient};
    color: ${({ theme }) => theme.colors.primary};
    padding: 1rem;
    height: max-content;
    border-radius: 5px;
    gap: 0.875rem;
    width: max-content;

    div {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
    }

    section {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.875rem;
    }

    div {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
    }

    h3 {
      font-weight: 600;
      line-height: 1.5rem;
      font-size: ${process.env.REACT_APP_CLEARSALE === "true"
        ? "0.975rem"
        : "1rem"};
    }

    .qrcode {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      padding: 1rem;
      border-radius: 5px;
      width: 100%;
    }

    .loader {
      margin: 6.5rem;
      border: 5px solid #000000;
      border-top: 5px solid #ffffff;
      border-radius: 50%;
      width: 72px;
      height: 72px;
      animation: spin 1.5s linear infinite;
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    p {
      padding: 0.75rem 0.625rem;
      font-weight: 400;
      font-size: 0.875rem;
      line-height: 128%;
      text-align: center;
      border: 2px solid
        ${({ theme }) => theme.backgrounds.defaultPrimaryClearsale};
      border-radius: 5px;
      width: 100%;

      span {
        font-weight: 700;
      }
    }
  }

  .orderClose {
    display: flex;
    flex-direction: column;
    border: 1px solid #dedede;
    border-radius: 5px;
    padding: 1rem;
    gap: 0.875rem;

    p {
      font-size: 0.875rem;
      font-weight: 500;
      color: ${({ theme }) => theme.black[900]};
    }

    .orderCloseBtn {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 2.5rem;
      background: #460259;
      text-decoration: none;
      border-radius: 5px;
      border: none;
      color: #ffffff;
      font-weight: 600;
    }
  }
`;

export const Products = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2rem;

  span {
    font-size: 0.75rem;
    margin-left: 0.75rem;
    color: #6bbfbf;
  }

  @media (max-width: 1200px) {
    align-items: center;
    .textTitle {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
`;
